(() => {
  const initBeforeAfter = (root) => {
    const range = root.querySelector('[data-before-after-range]');
    if (!range) return;

    const update = () => {
      root.style.setProperty('--ba-position', `${range.value}%`);
    };

    range.addEventListener('input', update);
    update();
  };

  const bootBeforeAfter = (scope = document) => {
    scope.querySelectorAll('[data-before-after]').forEach(initBeforeAfter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootBeforeAfter());
  } else {
    bootBeforeAfter();
  }

  document.addEventListener('shopify:section:load', (e) => {
    bootBeforeAfter(e.target);
  });
})();